import React from 'react'
import "./CreateScheduleNotification.css"
import i18next from 'i18next'
import moment from 'moment'
import 'moment/locale/es';
import 'moment/locale/fr';
import ButtonBack from '../../ManageAllOffers/DetailedOfferScreen/ButtonBack/ButtonBack';
import CreateScheduleNotificationForm from './CreateScheduleNotificationForm/CreateScheduleNotificationForm';
import { useTranslation } from 'react-i18next';


const CreateScheduleNotification = () => {

    const { t, i18n } = useTranslation()
    moment.locale(i18n.language)

    return (
        <div className="con-create-notification">

            <div className="con-p-left-notification">
                <p className="fs-18 fw-600">
                    {t("Notifications:schedule:index:label_42")}
                </p>

                <p className="fs-12 mt-16">
                    {`${t("Notifications:schedule:index:label_29")}: ${moment().format("D MMMM YYYY - HH[h]mm")}`}
                </p>
            </div>
            

            <div className="flex flex-ai-center">
                <ButtonBack />
                <div className="line-gray-help"></div>
            </div>

            <div className="con-p-left-notification center">
                
                <div className="con-p-inputs-notification">
                    <CreateScheduleNotificationForm type={"Create"} />
                </div>
                
            </div>

        </div>
    )
}

export default CreateScheduleNotification